<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else id="management" class="box">
    <transition name="fade" appear>
      <div>
        <div class="row">
          <div class="col">

            <h4>Groups</h4>
            <form v-for="(group,index) in groupList" :key="`groups-${index}`" :id="'group-form-'+index" @submit.prevent="updateGroup(index)">
              <div class="form-group">
                <div class="form-row">
                  <div class="col">
                    <input type="text" class="form-control details-input" :class="getSavingClass('group-'+index)" :id="'group-'+index" v-model="groupList[index]" required>
                  </div>
                  <div class="col">
                    <button class="btn btn-primary">Save</button>
                    <button type="button" class="btn btn-danger" @click="delGroup(index)">Delete</button>
                  </div>
                </div>
              </div>
            </form>
            <div>
              <button type="button" class="btn btn-success" @click="addGroup()">Add Group</button>
            </div>

            <h4>Accounts</h4>
            <form v-for="(account,index) in accounts" :key="`accounts-${index}`" :id="'account-form-'+index" @submit.prevent="updateAccount(index)">
              <div class="form-group">
                <div class="form-row">
                  <div class="col">
                    <input type="text" class="form-control" :class="getSavingClass('accounts-' + index)" :id="'accountId-'+index" v-model="accounts[index].id" minlength="12" maxlength="12" placeholder="account id" required>
                  </div>
                  <div class="col">
                    <input type="text" class="form-control" :class="getSavingClass('accounts-' + index)" :id="'accountName-'+index" v-model="accounts[index].name" placeholder="account name" required>
                  </div>
                  <div class="col-xs">
                    <button class="btn btn-primary">Save</button>
                    <button type="button" class="btn btn-danger" @click="delAccount(index)">Delete</button>
                  </div>
                </div>
              </div>
            </form>
            <div>
              <button type="button" class="btn btn-success" @click="addAccount()">Add Account</button>
            </div>

          </div>

          <div class="col">
            <h4>Slack</h4>
            <form id="slack" @submit.prevent="updateContractDetails('slack')">
              <div class="form-group">
                <input type="text" class="form-control text-input" :class="getSavingClass('slack')" id="slackTeamId" placeholder="slack team id" v-model="slack_team_id">
                <button class="btn btn-primary">Update Slack Team</button>
              </div>
            </form>

            <h4>Channel</h4>
            <form id="channel" @submit.prevent="updateContractDetails('channel')">
              <div class="form-group">
                <input type="text" class="form-control text-input" :class="getSavingClass('channel')" id="channelId" placeholder="channel id" v-model="channel_id">
                <button class="btn btn-primary">Update Channel ID</button>
              </div>
            </form>

            <h4>Zendesk</h4>
            <form id="channel" @submit.prevent="updateContractDetails('zendesk')">
              <div class="form-group">
                <input type="text" class="form-control text-input" :class="getSavingClass('zendesk')" id="zendeskGroupId" placeholder="zendesk group id" v-model="zendesk_group_id">
                <button class="btn btn-primary">Update Zendesk Group ID</button>
              </div>
            </form>

            <h4>Trello</h4>
            <form id="trello" @submit.prevent="updateContractDetails('trello')" ref="formContainer">
              <div class="form-group">
                <div v-for="(board,index) in trello_board_ids" :key="index" :id="'trello-inputs-'+index">
                  <div style="margin-bottom: 10px;">
                    <input type="text" class="form-control details-input" :class="getSavingClass('trello')" :id="'trelloTeamId-'+index" placeholder="trello board id" v-model="trello_board_ids[index]" required>
                    <button type="button" class="btn btn-danger trello-remove-btn" @click="delTrelloBoard(index)">Delete</button>
                    <div style="clear: both;"></div>
                  </div>
                </div>
                <div>
                  <button class="btn btn-primary">Update Boards</button>
                  <button type="button" class="btn btn-success" @click="addTrelloBoard()">Add</button>
                </div>
              </div>
            </form>

            <h4>OpsGenie Alternitive Integration Names</h4>
            <form id="opsGenie" @submit.prevent="updateContractDetails('opsgenie')">
              <div class="form-group">
                <div v-for="(alt,index) in opsgenie_alt" :key="index">
                  <div style="margin-bottom: 10px;">
                    <input type="text" class="form-control details-input" :class="getSavingClass('opsgenie')" :id="'opsGenieAlt-'+index" v-model="opsgenie_alt[index]" placeholder="alternative name" required>
                    <button type="button" class="btn btn-danger trello-remove-btn" @click="delOpsGenieAlt(index)">Delete</button>
                    <div style="clear: both;"></div>
                  </div>
                </div>
                <div>
                  <button class="btn btn-primary">Update OpsGenie</button>
                  <button type="button" class="btn btn-success" @click="addOpsGenieAlt()">Add</button>
                </div>
              </div>
            </form>

          </div>

          <div class="col">

            <h4>Jira Boards</h4>
            <form id="jira" @submit.prevent="updateContractDetails('jira')">
              <div v-for="(jboard,jboardindex) in jira_boards" :key="'jboard'+jboardindex">
                <div class="form-group">
                  <label for="jiraBoardId">Board Id</label>
                  <input type="text" class="form-control" style="max-width: 300px;" :class="getSavingClass('jira')" :id="'jiraBoardId-'+jboardindex" v-model="jira_boards[jboardindex].board_id" required>
                </div>
                <div class="form-group">
                  <label for="jiraInstanceName">Instance Name</label>
                  <input type="text" class="form-control" style="max-width: 300px;" :class="getSavingClass('jira')" :id="'jiraInstanceName-'+jboardindex" v-model="jira_boards[jboardindex].instance_name" required>
                </div>
                <div class="form-group">
                  <label for="jiraPlannedLists">Planned Lists</label>
                  <div v-for="(planned,index) in jboard.planned_lists" :key="index">
                    <div style="margin-bottom: 10px;">
                      <input type="text" class="form-control details-input" :class="getSavingClass('jira')" :id="'jiraPlannedLists-'+index" v-model="jboard.planned_lists[index]">
                      <button type="button" class="btn btn-danger details-remove-btn" @click="delJiraPlannedLists(jboard,index)">Delete</button>
                      <div style="clear: both;"></div>
                    </div>
                  </div>
                  <div>
                    <button type="button" class="btn btn-success" @click="addJiraPlannedLists(jboard)">Add</button>
                  </div>
                </div>
                <div class="form-group">
                  <label for="jiraInProgressLists">In Progress Lists</label>
                  <div v-for="(progress,index) in jboard.in_progress_lists" :key="index">
                    <div style="margin-bottom: 10px;">
                      <input type="text" class="form-control details-input" :class="getSavingClass('jira')" :id="'jiraInProgressLists-'+index" v-model="jboard.in_progress_lists[index]">
                      <button type="button" class="btn btn-danger details-remove-btn" @click="delJiraInProgressLists(jboard,index)">Delete</button>
                      <div style="clear: both;"></div>
                    </div>
                  </div>
                  <div>
                    <button type="button" class="btn btn-success" @click="addJiraInProgressLists(jboard)">Add</button>
                  </div>
                  <div style="margin-top: 10px;">
                    <button type="button" class="btn btn-danger" @click="delJiraBoard(jboardindex)">Delete Jira Board</button>
                  </div>
                </div>
              </div>
              <div>
                <button class="btn btn-primary">Update Jira Boards</button>
                <button type="button" class="btn btn-success" @click="addJiraBoard()">Add Jira Board</button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractModify',
  components: {
    VueLoading
  },
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'contracts',
      'groups'
    ])
  },
  data () {
    return {
      loading: false,
      isSaving: false,
      accounts: [],
      groupList: [],
      slack_team_id: null,
      channel_id: null,
      zendesk_group_id: null,
      trello_board_ids: [],
      opsgenie_alt: [],
      jira_boards: [],
      emptyJiraBoard: {
        planned_lists: [],
        instance_name: null,
        in_progress_lists: [],
        board_id: null
      }
    }
  },
  methods: {
    getAccounts: function () {
      HTTP.get(`/management/contract/${this.id}/accounts`)
        .then((response) => {
          this.accounts = response.data.accounts
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: 'Failed to retrieve accounts for ' + this.id + ' : ' + msg
          })
        })
    },
    getContractGroups: function () {
      HTTP.get(`/management/groups/${this.id}`)
        .then(response => {
          this.groupList = response.data.groups
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: 'Failed to retrieve groups for ' + this.id + ' : ' + msg
          })
        })
    },
    getContractDetails: function () {
      this.loading = true
      HTTP.get(`/management/contract/${this.id}`)
        .then((response) => {
          this.slack_team_id = (response.data.slack_team_id) ? response.data.slack_team_id : null
          this.channel_id = (response.data.channel_id) ? response.data.channel_id : null
          this.zendesk_group_id = (response.data.zendesk_group_id) ? response.data.zendesk_group_id : null
          this.trello_board_ids = (response.data.trello_board_ids) ? response.data.trello_board_ids : []
          this.opsgenie_alt = (response.data.opsgenie_alt) ? response.data.opsgenie_alt : []
          this.jira_boards = (response.data.jira_boards) ? response.data.jira_boards : []
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: 'Failed to retrieve deatils for contract ' + this.id + ' : ' + msg
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateContractDetails: function (type) {
      var data = {}
      this.isSaving = type
      switch (type) {
        case 'slack':
          data.slack_team_id = this.slack_team_id
          break

        case 'channel':
          data.channel_id = this.channel_id
          break

        case 'zendesk':
          data.zendesk_group_id = this.zendesk_group_id
          break

        case 'trello':
          data.trello_board_ids = this.trello_board_ids
          break

        case 'opsgenie':
          data.opsgenie_alt = this.opsgenie_alt
          break

        case 'jira':
          data.jira_boards = this.jira_boards
          break

        default:
          break
      }

      HTTP.put(`/management/contract/${this.id}`, data)
        .then(() => {
          this.isSaving = type + '-success'
          this.flashMessage.success({
            message: 'Successfully updated ' + type + ' configuration for ' + this.id
          })
        })
        .catch((error) => {
          this.isSaving = type + '-error'
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: 'Failed to update ' + type + ' configuration: ' + msg
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.isSaving = false
          }, 3000)
        })
    },
    updateAccount: function (index) {
      this.isSaving = 'accounts-' + index
      var account = this.accounts[index]
      var data = {account_name: account.name}

      HTTP.put(`/management/contract/${this.id}/account/${account.id}`, data)
        .then(() => {
          this.isSaving = 'accounts-' + index + '-success'
          this.flashMessage.success({
            message: 'Successfully updated ' + this.id + ' account ' + account.id
          })
        })
        .catch((error) => {
          this.isSaving = 'accounts-' + index + '-error'
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: 'Failed to create account ' + data.account_name + ' : ' + msg
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.isSaving = false
          }, 3000)
        })
    },
    delAccount: function (index) {
      this.isSaving = 'accounts-' + index
      var account = this.accounts[index]
      if (!account.id) {
        this.accounts.splice(index, 1)
      } else if (confirm('are you sure you want to remove the ' + this.id + ' account "' + account.name + '" from the base2 portal?')) {
        HTTP.delete(`/management/contract/${this.id}/account/${account.id}`)
          .then(() => {
            this.flashMessage.success({
              message: 'Successfully remove ' + this.id + ' account ' + account.id
            })
            this.accounts.splice(index, 1)
          })
          .catch((error) => {
            this.isSaving = 'accounts-' + index + '-error'
            var msg = (error.response) ? error.response.data.error : error.message
            this.flashMessage.error({
              message: 'Failed to delete account ' + account.name + ' : ' + msg
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    addTrelloBoard: function () {
      this.trello_board_ids.push('')
    },
    delTrelloBoard: function (index) {
      this.trello_board_ids.splice(index, 1)
    },
    addOpsGenieAlt: function () {
      this.opsgenie_alt.push('')
    },
    delOpsGenieAlt: function (index) {
      this.opsgenie_alt.splice(index, 1)
    },
    addJiraPlannedLists: function (jboard) {
      jboard.planned_lists.push('')
    },
    delJiraPlannedLists: function (jboard, index) {
      jboard.planned_lists.splice(index, 1)
    },
    addJiraInProgressLists: function (jboard) {
      jboard.in_progress_lists.push('')
    },
    delJiraInProgressLists: function (jboard, index) {
      jboard.in_progress_lists.splice(index, 1)
    },
    addJiraBoard: function () {
      this.jira_boards.push({...this.emptyJiraBoard})
    },
    delJiraBoard: function (index) {
      this.jira_boards.splice(index, 1)
    },
    addAccount: function () {
      this.accounts.push({id: null, name: null})
    },
    addGroup: function () {
      this.groupList.push(null)
    },
    delGroup: function (index) {
      this.isSaving = 'group-' + index
      var group = this.groupList[index]
      if (!group) {
        this.groupList.splice(index, 1)
      } else if (confirm('are you sure you want to remove the ' + this.id + ' from the "' + group + '" contract group?')) {
        HTTP.delete(`/management/group/${group}/contract/${this.id}`)
          .then(() => {
            this.flashMessage.success({
              message: 'Successfully removed ' + this.id + ' from the ' + group + 'contract group'
            })
            this.groupList.splice(index, 1)
          })
          .catch((error) => {
            this.isSaving = 'group-' + index + '-error'
            var msg = (error.response) ? error.response.data.error : error.message
            this.flashMessage.error({
              message: 'Failed to remove ' + this.id + ' from the ' + group + ' contract group : ' + msg
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    updateGroup: function (index) {
      this.isSaving = 'group-' + index
      var group = this.groupList[index]
      HTTP.put(`/management/group/${group}/contract/${this.id}`)
        .then(() => {
          this.isSaving = 'group-' + index + '-success'
          this.flashMessage.success({
            message: 'Successfully added ' + this.id + ' to group ' + group
          })
        })
        .catch((error) => {
          this.isSaving = 'group-' + index + '-error'
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: 'Failed to add ' + this.id + ' to group ' + group + ' : ' + msg
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.isSaving = false
          }, 3000)
        })
    },
    getSavingClass: function (type) {
      return [
        {'input-saving': this.isSaving === type},
        {'input-success': this.isSaving === type + '-success'},
        {'input-error': this.isSaving === type + '-error'}
      ]
    }
  },
  created: function () {
    this.getAccounts()
    this.getContractGroups()
    this.getContractDetails()
  },
  watch: {
    id: function () {
      if (this.groups.includes(this.id)) {
        this.$router.push({ name: 'GroupModify', params: { id: this.id } })
      } else if (this.contracts.includes(this.id)) {
        this.getAccounts()
        this.getContractGroups()
        this.getContractDetails()
      } else {
        this.$router.push({ name: 'Home' })
      }
    }
  }
}
</script>

<style scoped>
h4 {
  margin-top: 15px;
}
.row {
  padding: 20px;
}
.account-rows {
  padding-bottom: 10px;
}
.details-input {
  max-width: 300px;
  margin-right: 20px;
  float: left;
}
.details-remove-btn {
  float: left;
}
.slack-submit {
  float: left;
}
.text-input {
  max-width: 300px;
  margin-bottom: 10px;
}
.input-saving {
  border-color: #70A1F0;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  box-shadow: 0 0 5px #70A1F0;
}
.input-success {
  border-color: #12961a;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  box-shadow: 0 0 5px #12961a;
}
.input-error {
  border-color: #e94949;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  box-shadow: 0 0 5px #e94949;
}
</style>

<style scoped src='../assets/stylesheet/transitions.css'></style>



// WEBPACK FOOTER //
// src/views/ContractModify.vue